import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { PrescriptionReportProps } from '../../interfaces/pep/prescription-report-props';
import { HttpMethod, HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { Value } from '@philips-internal/oswald-ui-core';

class PrescriptionReportService {

  generateReport(payload: PrescriptionReportProps): Promise<string> {
    const params = { encounterId: payload.encounterId };
    const body = Object.assign(params, payload) as unknown as Record<string, Value>;

    return HttpService.fetch<Blob>({
      body,
      endpoint: Endpoint.PEP_PRESCRIPTION_REPORT,
      endpointParameters: params,
      method: HttpMethod.POST
    }).then(response => {
      const file = new Blob([response.body as Blob], { type: 'application/pdf' });
      return URL.createObjectURL(file) + '#toolbar=0';
    })
  }

  generateReportImages(payload: PrescriptionReportProps): Promise<HttpResponse<unknown>> {
    const params = { encounterId: payload.encounterId };
    const body = Object.assign({}, payload) as unknown as Record<string, Value>;
    return HttpService.post(Endpoint.PEP_PRESCRIPTION_REPORT_IMAGES, params, { body });
  }

  getReportImage(path: string): Promise<Record<string, Value>> {
    const route = Endpoint.GET_REPORT_IMAGE + `?path=${path}`;
    const headers = { accept: 'image/png' };

    return HttpService.fetch<Blob>({
      endpoint: route,
      headers,
      method: HttpMethod.GET,
    })
      .then((response: HttpResponse<Blob>) => {
        return response.body || new Blob();
      })
      .then(blob => {
        const src = URL.createObjectURL(blob);

        return ({ src });
      });
  }
}

export default PrescriptionReportService;